module.exports = __webpack_public_path__ + "bef87f4e99dc23fa65801992f3cc66f3.pdf";